document.addEventListener("DOMContentLoaded", function () {
  let observer;
  let isLoading = false;

function setupInfiniteScroll() {
  const nextPageLink = document.querySelector(".pagination-wrapper .next-page");
  const productGrid = document.querySelector(".product-grid");

  if (!nextPageLink || !productGrid) return;

  let loader = document.getElementById("infinite-loader");
  if (!loader) {
    loader = document.createElement("div");
    loader.id = "infinite-loader";
    loader.style.textAlign = "center";
    loader.style.padding = "20px";

    const img = document.createElement("img");
    img.src = "https://newyorkornowhere.com/cdn/shop/t/104/assets/Circle-Loading.svg";
    img.alt = "Loading...";
    img.style.width = "40px";
    img.style.height = "40px";

    loader.appendChild(img);
    productGrid.insertAdjacentElement("afterend", loader);
  }

  if (observer) observer.disconnect();

  observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && !isLoading) {
      loadMoreProducts();
    }
  }, {
    rootMargin: "200px"
  });

  observer.observe(nextPageLink);
}


  function loadMoreProducts() {
    const nextPageLink = document.querySelector(".pagination-wrapper .next-page");
    if (!nextPageLink) return;

    isLoading = true;
    document.getElementById("infinite-loader").style.display = "block";

    fetch(nextPageLink.href)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProducts = doc.querySelector(".product-grid");
        const newPagination = doc.querySelector(".pagination-wrapper");

        if (newProducts) {
          document.querySelector(".product-grid").insertAdjacentHTML("beforeend", newProducts.innerHTML);
        }

        if (newPagination) {
          document.querySelector(".pagination-wrapper").innerHTML = newPagination.innerHTML;
        } else {
          document.querySelector(".pagination-wrapper")?.remove();
        }

        document.getElementById("infinite-loader").style.display = "none";
        isLoading = false;

        // Re-attach observer to new pagination link
        setupInfiniteScroll();
      })
      .catch(error => {
        console.error("Error loading products:", error);
        isLoading = false;
        document.getElementById("infinite-loader").style.display = "none";
      });
  }

  // Initial trigger
  setupInfiniteScroll();

  // Filter AJAX system DOM update pe dobara initialize
  const ajaxContainer = document.querySelector("[data-ajax-container]");
  const config = { childList: true, subtree: true };

  if (ajaxContainer) {
    const mutationObserver = new MutationObserver(() => {
      setupInfiniteScroll();
    });
    mutationObserver.observe(ajaxContainer, config);
  }
});

